/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import { Col, Row } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useState } from "react";
import DokanProfileCompleteStatus from "../../components/DokanProfileCompleteStatus";
import DokanPageTitle from "../../components/text/DokanPageTitle";
// import AnnouncementsHighlights from "./announcementsHighlights/AnnouncementsHighlights";
// import CouponHighlights from "./couponHighlights/CouponHighlights";
import OrdersHighlights from "./orderHighlights/OrdersHighlights";
import Overview from "./overview/Overview";
import ProductsHighlights from "./productHighlights/ProductsHighlights";
// import ReviewHighlights from "./reviewHighlights/ReviewHighlights";
import SalesReport from "./salesReportHighlights/SalesReportHighlights";

function Dashboard() {
  // State control from Profile Completeness Section
  const [isHidden, setIsHidden] = useState(false);
  // Event to show-hide Profile Completeness Section
  const handleIsHidden = () => {
    setIsHidden(true);
  };

  return (
    <>
    <div className="container p-6 mx-auto md:px-10 md:py-12 grid gap-5">

      <div className="hidden md:block"><DokanPageTitle>Overview</DokanPageTitle></div>

      <div> <DokanProfileCompleteStatus handleIsHidden={handleIsHidden} /></div>

      <div><Overview /></div>
      <div><SalesReport /></div>
      <div className="grid grid-cols-1 row-gap-5 lg:grid-cols-12 lg:col-gap-5"> 
      <div className="col-span-6"><OrdersHighlights /></div>
      <div className="col-span-6"> <ProductsHighlights /></div>
      </div>
    </div>
    
    </>
  );
}

export default Dashboard;
